export const currencySymbols = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  BRL: 'R$',
};
